export enum TextNotesStatus {
  NOT_INITIATED = "",
  INITIATED = "initiated",
  IN_PROGRESS = "in_progress",
  NOT_APPLICABLE = "not_applicable",
  UPLOADED_UNSIGNED = "uploaded_unsigned",
  COMPLETED = "completed",
  FAILED = "failed",
}
